import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { GrFormNextLink } from "react-icons/gr";
import { IoMdArrowBack } from "react-icons/io";
import { IoArrowBackOutline } from "react-icons/io5";
import { MdDone } from "react-icons/md";
const PublicPopup = ({ closeTutorialModal }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const videos = [
    {
      video:
        "https://res.cloudinary.com/dccfiolig/video/upload/v1738823780/video2_ksaw8q.mp4",
      heading: "Change filters from right sidebar ",
    },
    {
      video:
        "https://res.cloudinary.com/dccfiolig/video/upload/v1738823780/video3_atdzzz.mp4",
      heading: "Double click on bar to see trend",
    },
    {
      video:
        "https://res.cloudinary.com/dccfiolig/video/upload/v1738823780/video4_jaxcoy.mp4",
      heading: "Change sheets from the top",
    },
  ];

  const handleConfirm = () => {
    closeTutorialModal();
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < videos.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <main className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-10 backdrop-blur-sm">
      <main className="bg-white rounded shadow-lg flex flex-col items-start justify-center gap-1">
        <header className="bg-gray-50 p-1 flex items-center justify-between w-full font-semibold rounded">
          {/* Features */}
          <img
            src={`https://res.cloudinary.com/dccfiolig/image/upload/v1739339785/Auto_Panditz_Logo_vchwfr.png`}
            width={"100"}
          />
          <RxCross2
            onClick={closeTutorialModal}
            className="cursor-pointer text-black"
          />
        </header>

        <div className="text-lg font-semibold w-full text-center">
          {videos[currentIndex].heading}
        </div>

        <div className="flex justify-center">
          <video
            className="w-[50rem] h-[24rem] object-cover mb-2"
            src={videos[currentIndex].video}
            autoPlay
            loop
            muted
          />
        </div>
        <div className="flex justify-center space-x-2 items-center w-full">
          {videos.map((_, index) => (
            <span
              key={index}
              className={`w-2.5 h-2.5 rounded-full ${
                currentIndex === index ? "bg-blue-950" : "bg-gray-300"
              }`}
            ></span>
          ))}
        </div>

        <footer className="flex justify-between w-full items-center p-1 bg-gray-50">
          <button
            onClick={handlePrevious}
            className={`px-4 py-2 rounded flex items-center justify-center gap-2 ${
              currentIndex === 0 ? "bg-gray-300" : "bg-blue-950"
            } text-white`}
            disabled={currentIndex === 0}
          >
            <IoArrowBackOutline className="text-xl" />
            Previous
          </button>
          {currentIndex < videos.length - 1 ? (
            <button
              onClick={handleNext}
              className="px-4 py-2 bg-blue-950 text-white rounded flex items-center justify-center gap-1 tracking-wide"
            >
              Next
              <GrFormNextLink className="text-2xl" />
            </button>
          ) : (
            <button
              onClick={handleConfirm}
              className="px-4 py-2 bg-blue-950 text-white rounded flex items-center justify-center gap-2 tracking-wide"
            >
              Finished
              <MdDone className="text-2xl" />
            </button>
          )}
        </footer>
      </main>
    </main>
  );
};

export default PublicPopup;
